// internal-deps
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";
import { ISender } from "@swiggy-private/dineout-cart-ui";

// constants
import { SCREEN_NAME, IMPRESSION_ACTIONS, CLICK_ACTIONS } from "@dineout-cart-client/analytics/constants";

export const impressionDineCashPoolingScreen = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    amount: number,
    state: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.DINE_CASH_POOLING,
        action: IMPRESSION_ACTIONS.IMPRESSION_DINECASH_POOLING_SCREEN,
        label: String(amount ?? 0),
        context: JSON.stringify({ state }),
    });
};

export const impressionDineCashQrCode = (impressionEvent: AnalyticsContextValue["impressionEvent"]): void => {
    impressionEvent({
        category: SCREEN_NAME.DINE_CASH_POOLING,
        action: IMPRESSION_ACTIONS.IMPRESSION_DINECASH_QR_CODE,
    });
};

export const impressionDineCashWhatsAppShare = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    text: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.DINE_CASH_POOLING,
        action: IMPRESSION_ACTIONS.IMPRESSION_DINECASH_WHATSAPP_SHARE,
        label: text,
    });
};

export const clickDineCashWhatsAppShare = (clickEvent: AnalyticsContextValue["clickEvent"], text: string): void => {
    clickEvent({
        category: SCREEN_NAME.DINE_CASH_POOLING,
        action: CLICK_ACTIONS.CLICK_DINECASH_WHATSAPP_SHARE,
        label: text,
    });
};

export const impressionDineCashLedger = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    maxPoolAmountReached: boolean,
    totalAmountReceived: number,
    senders?: ISender,
): void => {
    impressionEvent({
        category: SCREEN_NAME.DINE_CASH_POOLING,
        action: IMPRESSION_ACTIONS.IMPRESSION_DINECASH_LEDGER,
        context: JSON.stringify({
            maxPoolAmountReached,
            totalAmountReceived,
            senders,
        }),
    });
};

export const impressionDineCashDoneBtn = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    text: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.DINE_CASH_POOLING,
        action: IMPRESSION_ACTIONS.IMPRESSION_DINECASH_DONE_CTA,
        label: text,
    });
};

export const impressionDineCashPoolingGratification = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.DINE_CASH_POOLING,
        action: IMPRESSION_ACTIONS.IMPRESSION_DINECASH_POOL_GRATIFICATION,
    });
};

export const clickDineCashDoneBtn = (clickEvent: AnalyticsContextValue["clickEvent"], text: string): void => {
    clickEvent({
        category: SCREEN_NAME.DINE_CASH_POOLING,
        action: CLICK_ACTIONS.CLICK_DINECASH_DONE_CTA,
        label: text,
    });
};
